import { Timestamp } from 'firebase/firestore';

export function useFormatUtils() {
  const formatDate = (timestamp: Timestamp | number | null | undefined) => {
    if (!timestamp) return 'Never';
    if (typeof timestamp === 'number') {
      return new Date(timestamp).toLocaleString();
    }
    if (timestamp && typeof timestamp === 'object' && 'toDate' in timestamp) {
      return timestamp.toDate().toLocaleString();
    }
    return 'Invalid date';
  };

  const formatTimeSince = (timestamp: number | null) => {
    if (!timestamp) return 'Never';
    const now = Date.now();
    const diffMs = now - timestamp;
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));

    if (diffDays > 0) return `${diffDays} days ago`;
    if (diffHours > 0) return `${diffHours} hours ago`;
    return 'Less than an hour ago';
  };

  const formatActionName = (action: string) => {
    return action.replace('_', ' ');
  };

  const capitalizeFirst = (str: string) => {
    return str.charAt(0).toUpperCase() + str.slice(1).replace('_', ' ');
  };

  return {
    formatDate,
    formatTimeSince,
    formatActionName,
    capitalizeFirst,
  };
}
